<template>
  <!-- Home Section 03 -->
  <div class="registrtion">
    <div class="row">
      <section>
        <transition name="fade" appear>
          <div class="modal-overlay" v-if="pop_show"></div>
        </transition>
        <transition name="slide" appear>
          <div class="modal" v-if="pop_show">
            <div><img src="../assets/img/leave.png" width="15%" /></div>
            <h1>
              Are you sure you want to <br />
              leave this page
            </h1>
            <div class="row section_3-button">
              <div class="col">
                <button @click="pop_show = false" type="submit" class="popup-button">
                  Stay on this Page
                </button>
              </div>
              <div class="col">
                <router-link to="/">
                  <button type="submit" class="popup-button_b">
                    Leave this Page
                  </button></router-link
                >
              </div>
            </div>
          </div>
        </transition>
      </section>
      <div class="col registration" style="width: 50%" data-aos="fade-right">
        <VueSlickCarousel
          ref="c1"
          class="slick_head"
          :asNavFor="$refs.c2"
          :focusOnSelect="true"
          :autoplay="true"
          :autoplaySpeed="4000"
          :speed="300"
          :slidesToShow="1"
          @beforeChange="syncSliders"
        >
          <img class="" src="../assets/img/Registration_1.jpg" />
          <img class="" src="../assets/img/Registration_2.jpg" />
          <img class="" src="../assets/img/Registration_1.jpg" />
          <img class="" src="../assets/img/Registration_1.jpg" />
          <img class="" src="../assets/img/Registration_2.jpg" />
          <template #prevArrow="">
            <div class=""></div>
          </template>
          <template #nextArrow="">
            <div class=""></div>
          </template>
        </VueSlickCarousel>
        <div class="reg_head_2">
          <VueSlickCarousel
            ref="c2"
            v-bind="settings"
            :asNavFor="$refs.c1"
            :focusOnSelect="true"
            :accessibility="true"
            @beforeChange="syncSliders"
          >
            <img class="" src="../assets/img/Registration_1.jpg" />
            <img class="" src="../assets/img/Registration_2.jpg" />
            <img class="" src="../assets/img/Registration_1.jpg" />
            <img class="" src="../assets/img/Registration_1.jpg" />
            <img class="" src="../assets/img/Registration_2.jpg" />

            <template #prevArrow="">
              <div class="custom-arrow"></div>
            </template>
            <template #nextArrow="">
              <div class="reg_custom-arrow">
                <span class="next_icon_slick"></span>
              </div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>

      <div class="col" data-aos="fade-left">
        <div class="container">
          <div class="reg_left">
            <div class="row count_body">
              <div class="col">
                <h2 class="count_head">Registration</h2>
              </div>
              <div class="col">
                <h2 class="title_is">
                  4 <span>/ {{ count }}</span>
                </h2>
              </div>
            </div>
            <ValidationObserver ref="observer" v-if="step === 1" class="reg_body_tag">
              <b-form
                slot-scope="{ validate }"
                @submit.prevent="validate().then(handleSubmit)"
              >
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider
                      rules="required|alpha_spaces"
                      name="Name"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.name"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Name*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- v-bind:class="[isActive ? 'red' : 'blue']" @click="toggleClass()" -->
                <div class="row three_row select_three_row">
                  <div class="col-md-4">
                    <ValidationProvider
                      rules="required"
                      name="calender"
                      class="reg_body_fv calender"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <Datepicker
                          name="startDate"
                          class="startDate"
                          id="startDate"
                          v-model="user.date"
                          :initialView="'year'"
                          :disabledDates="disabledDates"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="00-00-00"
                          :format="'dd-MM-yyyy'"
                          @input="colorChange()"
                        />
                        <span class="calender_icon"
                          ><i class="fas fa-calendar-alt"></i
                        ></span>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-4">
                    <ValidationProvider
                      rules="required"
                      name="gender"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-select
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.gender"
                        >
                          <option value>Gender</option>
                          <option value="CA">male</option>
                          <option value="IL">female</option>
                          <option value="LA">others</option> </b-form-select
                        ><span class="drop_down"
                          ><i class="fas fa-caret-down" aria-hidden="true"></i
                        ></span>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-4">
                    <ValidationProvider rules="required" name="blood" class="reg_body_fv">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-select
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.blood"
                        >
                          <option value>Blood Group</option>
                          <option value="CA">O+</option>
                          <option value="IL">B+</option>
                          <option value="LA">AB+</option>
                          <option value="NM">A+</option> </b-form-select
                        ><span class="drop_down"
                          ><i class="fas fa-caret-down" aria-hidden="true"></i
                        ></span>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider
                      rules="required|email"
                      name="Email"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="email"
                          v-model="user.email"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Email*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row two_row">
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|"
                      name="Mobile"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.mobile"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Mobile number"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|"
                      name="Mobile2"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.mobile2"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Mobile number 2"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row two_row">
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|alpha_spaces"
                      name="Educational_Qualifications"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-select
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.Educational"
                        >
                          <option value>Educational Qualifications</option>
                          <option value="CA">empty</option>
                          <option value="IL">empty</option>
                          <option value="LA">empty</option>
                          <option value="NM">empty</option> </b-form-select
                        ><span class="drop_down"
                          ><i class="fas fa-caret-down" aria-hidden="true"></i
                        ></span>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|alpha_spaces"
                      name="Professional Qualifications"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-select
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.Professional"
                        >
                          <option value>Professional Qualifications</option>
                          <option value="CA">empty value</option>
                          <option value="IL">empty value</option>
                          <option value="LA">empty value</option> </b-form-select
                        ><span class="drop_down"
                          ><i class="fas fa-caret-down" aria-hidden="true"></i
                        ></span>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row one_row">
                  <div class="col-md-12">
                    <ValidationProvider
                      rules="required|alpha_spaces"
                      name="Education Background"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.Background"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Education Background*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row two_row">
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required"
                      name="Address"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.Address"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Address*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|alpha_spaces"
                      name="State"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.State"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="State*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row two_row">
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|alpha_spaces"
                      name="City"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.City"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="City*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required"
                      name="Country"
                      class="reg_body_fv"
                    >
                      <b-form-group class="country_body" slot-scope="{ valid, errors }">
                        <b-form-select
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.Country"
                        >
                          <option value>Country</option>
                          <option value="CA">male</option>
                          <option value="IL">female</option>
                          <option value="LA">others</option> </b-form-select
                        ><span class="drop_down"
                          ><i class="fas fa-caret-down" aria-hidden="true"></i
                        ></span>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row one_row">
                  <div class="col-md-12">
                    <ValidationProvider
                      rules="required"
                      name="Social Media Link"
                      class="reg_body_fv"
                    >
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-input
                          type="text"
                          v-model="user.Social"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Social Media Link*"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="">
                  <div class="button_next button_1">
                    <button
                      @click.prevent="next()"
                      class="button_body_1"
                      block
                      type="submit"
                      variant="primary"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>

            <ValidationObserver
              ref="observer"
              v-if="step === 2"
              name="fade"
              class="animation_colum"
              mode="out-in"
            >
              <b-form
                slot-scope="{ validate }"
                class="animation_button"
                @submit.prevent="validate().then(handleSubmit)"
              >
                <div class="row">
                  <div class="col-md-12">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p># Want to work as a volunteer?</p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="one" name="radio-button" />
                                <span> Directly</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="two" name="radio-button" />
                                <span> Online</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="three" name="radio-button" />
                                <span> Both</span>
                              </label>
                            </div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p># How can you volunteer your time?</p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="four" name="radio2" />
                                <span class="checkmark"> Mornings (Sun-Thurs)</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="five" name="radio2" />
                                <span class="checkmark"> Afternoons (Sun-Thurs)</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="six" name="radio2" />
                                <span class="checkmark"> Evenings (Sun-Thurs)</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="seven" name="radio2" />
                                <span class="checkmark"> One Time Only</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="eight" name="radio2" />
                                <span class="checkmark"> More Than Once A Week</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="ten" name="radio2" />
                                <span class="checkmark"> As Needed</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" value="elven" name="radio2" />
                                <span class="checkmark"> Weekends</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="twoelve" name="radio2" />
                                <span class="checkmark"> Others</span>
                              </label>
                            </div>
                            <div class="column_check"></div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p># What kind of work are you interested in as a volunteer?</p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Administrative Support</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark">
                                  Physician Directory Specialist</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Grant writer</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Translator</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Photography</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Social Media Researcher</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Support Leaders</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Spokesperson</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Event management</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark">
                                  Providing emergency services</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Others</span>
                              </label>
                            </div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <div slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p># Your special skills?</p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Event Management</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Photography</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Report Writing</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Graphics Design</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Computer and Technology</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Digital Marketing</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Public Speaking</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Translator</span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="checkbox" />
                                <span class="checkmark"> Others</span>
                              </label>
                            </div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row step_two_button">
                  <div class="col">
                    <div class="container">
                      <button
                        @click.prevent="prev()"
                        class="button_body_pre"
                        block
                        type="submit"
                        variant="primary"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  <div class="col">
                    <div class="container">
                      <button
                        @click.prevent="next()"
                        class="button_body_steptwo"
                        block
                        type="submit"
                        variant="primary"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>

            <ValidationObserver
              ref="observer"
              v-if="step === 3"
              name="fade"
              class="animation_colum"
              mode="out-in"
            >
              <b-form
                slot-scope="{ validate }"
                class="animation_button"
                @submit.prevent="validate().then(handleSubmit)"
              >
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p>
                            # Do you have previous experience in unpaid volunteer work?
                          </p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio1" />
                                <span class="checkmark"> Yes</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio1" />
                                <span class="checkmark"> No</span>
                              </label>
                            </div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p># Are you involved with any voluntary organizations?</p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio" />
                                <span class="checkmark"> Yes</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio" />
                                <span class="checkmark"> No</span>
                              </label>
                            </div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider name="anything" rules="required">
                      <b-form-group slot-scope="{ valid, errors }">
                        <p># Are you involved with any voluntary organizations?</p>
                        <b-form-input
                          type="text"
                          v-model="user.anything"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="Anything"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider name="Hobbies" rules="required|length:1">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p># Do You Have A Valid (State) Driver’s License?</p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio2" />
                                <span class="checkmark"> Yes</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio2" />
                                <span class="checkmark"> No</span>
                              </label>
                            </div>
                          </div>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row two_row">
                  <div class="col-md-6">
                    <ValidationProvider rules="required" name="License">
                      <b-form-group slot-scope="{ valid, errors }">
                        <p>License Number</p>
                        <b-form-input
                          type="text"
                          v-model="user.License"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="*****"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider rules="required|alpha_spaces" name="Vehicle">
                      <b-form-group slot-scope="{ valid, errors }">
                        <p>Vehicle License Plate Number</p>
                        <b-form-input
                          type="text"
                          v-model="user.Vehicle"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="****"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row two_row">
                  <div class="col-md-6">
                    <ValidationProvider rules="required" name="Insurance">
                      <b-form-group slot-scope="{ valid, errors }">
                        <p>Insurance Company</p>
                        <b-form-input
                          type="text"
                          v-model="user.Insurance"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="*****"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider rules="required|alpha_spaces" name="Policy">
                      <b-form-group slot-scope="{ valid, errors }">
                        <p>Policy</p>
                        <b-form-input
                          type="text"
                          v-model="user.Policy"
                          :state="errors[0] ? false : valid ? true : null"
                          placeholder="****"
                        ></b-form-input>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row step_two_button">
                  <div class="col">
                    <div class="container">
                      <button
                        @click.prevent="prev()"
                        class="button_body_pre"
                        block
                        type="submit"
                        variant="primary"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  <div class="col">
                    <div class="container">
                      <button
                        @click.prevent="next()"
                        class="button_body_steptwo"
                        block
                        type="submit"
                        variant="primary"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>

            <ValidationObserver
              ref="observer"
              v-if="step === 4"
              class="animation_colum"
              name="fade"
              mode="out-in"
            >
              <b-form
                slot-scope="{ validate }"
                class="animation_button"
                @submit.prevent="validate().then(handleSubmit)"
              >
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider name="Hobbies" rules="required">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p>
                            # Do you have previous experience in unpaid volunteer work?
                          </p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio5" />
                                <span class="checkmark"> Yes</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio5" />
                                <span class="checkmark"> No</span>
                              </label>
                            </div>
                          </div>
                          <b-form-input
                            type="text"
                            v-model="user.Explain"
                            :state="errors[0] ? false : valid ? true : null"
                            placeholder="If yes, Please Explain"
                          ></b-form-input>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row">
                    <ValidationProvider name="Hobbies" rules="required">
                      <b-form-group slot-scope="{ valid, errors }">
                        <b-form-checkbox-group
                          :state="errors[0] ? false : valid ? true : null"
                          v-model="user.hobbies"
                        >
                          <p>
                            # Do You Have Any Physical Condition that May Limit Your
                            Activities?
                          </p>
                          <div class="row">
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio6" />
                                <span class="checkmark"> Yes</span>
                              </label>
                            </div>
                            <div class="column_check">
                              <label class="container">
                                <input type="radio" checked="checked" name="radio6" />
                                <span class="checkmark"> No</span>
                              </label>
                            </div>
                          </div>
                          <b-form-input
                            type="text"
                            v-model="user.Describe"
                            :state="errors[0] ? false : valid ? true : null"
                            placeholder="If yes, Describe"
                          ></b-form-input>
                        </b-form-checkbox-group>
                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row permission_text">
                    <h4>Regarding permission to use the information you provide</h4>
                    <p>
                      ***The information you provide for volunteer registration will be
                      used in our
                      <br />conducted activities with the utmost confidentiality. This
                      information will not be <br />exchanged with any third party or
                      organization in the interest of commercial <br />promotion.
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 one_row permission_text">
                    <label class="container">
                      <input type="checkbox" name="checkbox" />
                      <span class="checkmark">
                        I have read the message above and am volunteering to
                        participate.</span
                      >
                    </label>
                  </div>
                </div>
                <div class="row step_two_button">
                  <div class="col">
                    <div class="">
                      <button
                        @click.prevent="next()"
                        class="button_body_submit"
                        block
                        type="submit"
                        variant="primary"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>

            <div
              ref="observer"
              v-if="step === 5"
              name="fade"
              mode="out-in"
              class="animation_colum"
            >
              <b-form>
                <div class="row animation_button">
                  <div class="col-md-12 one_row">
                    <div class="Congratulations_body">
                      <img class="logo" src="../assets/img/Congratulations.png" />
                      <div class="congrats_body">
                        <h2>Congratulations</h2>
                        <p>Your registration has</p>
                        <p>been successful</p>

                        <button
                          class="button_body_con"
                          block
                          type="submit"
                          variant="primary"
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VueSlickCarousel,
    Datepicker,
  },
  data: () => ({
    settings: {
      centerMode: 3,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            centerMode: 2,
            slidesToShow: 2,
          },
        },
      ],
    },
    pop_show: false,
    count: 1,
    step: 1,
    disabledDates: {
      to: new Date(1920, 0, 0), // Disable all dates up to specific date
      from: new Date(Date.now()),
    },
    user: {
      name: "",
      email: "",
      mobile: "",
      mobile2: "",
      date: "",
      //model:" 00/00/0000",
      gender: "",
      blood: "",
      Professional: "",
      Educational: "",
      Background: "",
      Address: "",
      State: "",
      City: "",
      Country: "",
      Social: "",
      anything: "",
      License: "",
      Vehicle: "",
      Insurance: "",
      Policy: "",
      Explain: "",
      Describe: "",
    },
  }),
  mounted() {
    // let today = new Date().toISOString().substr(0, 10);
    ///document.querySelector("#startDate").value = today;
    // or...
    //document.querySelector("#startDate").valueAsDate = new Date();
    console.clear();
  },
  methods: {
    next() {
      this.count += 1;
      this.pop_show = true;
      this.step++;
    },
    prev() {
      this.step--;
    },
    syncSliders() {
      this.$refs.c1.next();
      this.$refs.c2.next();
    },
    toggleClass() {
      this.isActive = !this.isActive;
    },
    colorChange() {
      document.getElementById("startDate").classList.add("colorChange_startDate");
    },
  },
};
</script>

<style scoped>
@import "/assets/css/slick-theme2.css";
input[type="date"]::-webkit-calendar-picker-indicator {
  color: #07cddb !important;
  opacity: 1;
  /* background: url() center/80% no-repeat; */
  color: #07cddb !important;
}

input[type="date"]::-webkit-calendar-picker-indicator:hover {
  /* background: url() center/80% no-repeat; */
  color: #07cddb !important;
  opacity: 1;
}
.Congratulations_body .logo {
  width: auto !important;
}
.modal-overlay {
  position: fixed;
  top: -100vh;
  left: 0;
  right: 0;
  bottom: -100vh;
  z-index: 1021;
  background-color: rgb(8 8 8 / 75%);
  height: auto;
  width: 100%;
  overflow: hidden;
}

.three_row .form-control {
  width: 32% !important;
  background: #fff0;
  border: 0px solid #fff0;
  border-bottom: 2px solid #565555;
  font-weight: 600;
  padding: 0;
  border-radius: 0px;
}

.popup-button {
  padding: 10px 25px;
  background: #07cddb;
  border-radius: 50px;
  color: #000;
  font-weight: 600;
}
.popup-button_b {
  padding: 10px 30px;
  background: #000;
  border-radius: 50px;
  color: #fff;
  font-weight: 600;
}
.section_3-button .col {
  flex-basis: 0;
}
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 99;
  display: block;
  width: 100%;
  max-width: 700px;
  border-radius: 16px;
  padding: 25px;
  height: auto;
  z-index: 1022;
  text-align: center;
  z-index: 1032 !important;
}
.modal h1 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.modal p {
  color: #666;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 15px;
}
.button {
  float: right;
  right: 0px;
  padding-right: -20px;
  position: absolute;
  top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-50%) translateY(100vw);
}
#test {
  width: 100%;
  position: absolute;
  margin-top: -150px;
}
.reg_left {
  padding-top: 70px;
  width: 90%;
  margin-left: 40px;
}
.next_icon_slick {
  width: 50px;
  height: 2px;
  background: #07cddb;
}
.reg_left h2 {
  padding: 30px 0px;
}
.registration .image {
  padding-bottom: 20px;
}
/* pretty radio */
label > input[type="radio"] {
  display: none;
}
label > input[type="radio"] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 12px;
  height: 12px;
  margin-right: 0.3rem;
  border-radius: 50px;
  border-style: solid;
  border-width: 0.01rem;
  border-color: #706f6f;
  background-color: #ffffff;
  margin-top: 4px;
  position: absolute;
  margin-left: -18px;
}
label {
  display: inline-block;
  margin-top: 0;
  margin-bottom: 0rem;
}
label > input[type="radio"]:checked + *::before {
  background: #07cddb;
  border-color: #07cddb;
  border-color: #706f6f;
}

span {
  font-size: 13px;
}
label > input[type="radio"] + * {
  display: inline-block;
}
/* pretty radio */
label > input[type="checkbox"] {
  display: none;
}
label > input[type="checkbox"] + *::before {
  content: "";
  display: inline-block;
  vertical-align: bottom;
  width: 12px;
  height: 12px;
  margin-right: 0.3rem;
  border-radius: 0;
  border-style: solid;
  border-width: 0.01rem;
  border-color: #706f6f;
  background-color: #ffffff;
  margin-top: 4px;
  position: absolute;
  margin-left: -18px;
}
.calender_icon {
  color: #07cddb;
  position: absolute;
  justify-content: right;
  right: 0px;
  top: 10px;
  z-index: -1;
}
label > input[type="checkbox"]:checked + *::before {
  background: #07cddb;
  border-color: #07cddb;
}

label > input[type="checkbox"] + * {
  display: inline-block;
}
.custom-select {
  /* background: url()
    no-repeat right 0.1rem center/8px 10px; */
}
.drop_down {
  color: #07cddb;
  position: top;
  top: 11px;
  /* right: 0; */
  right: 0px;
  position: absolute;
  z-index: -1;
}
.custom-select.is-valid,
.was-validated .custom-select:valid,
.form-control.is-valid,
.was-validated .form-control:valid {
  border-bottom: 2px solid #07cddb !important;
  background-image: none;
  box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 0%);
}
.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  box-shadow: none;
  border-bottom: 2px solid #07cddb;
}
.form-control.is-invalid,
.was-validated .form-control:invalid {
  padding-right: 0px !important;
  border-color: #0000;
  border-bottom: 2px solid red;
}
.form-control.is-valid,
.was-validated .form-control:valid {
  border-bottom: 2px solid #07cddb;
  border-color: #0000;
}

.custom-select.is-valid:focus,
.was-validated .custom-select:valid:focus {
  box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 0%);
}
.form-control.is-invalid,
.was-validated .form-control:invalid {
  padding-right: calc(1.5em + 0.75rem);
  /* background-image: url(); */
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgb(220 53 69 / 0%);
}
.button_reg_body {
  position: absolute;
}
.one_row .form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  border: none;
  background-color: #fff0;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-bottom: 2px solid #565555;
  border-radius: 0px;
  padding: 0px;
}
.one_row {
  width: 99%;
}
.two_row .form-control {
  display: block;
  width: 49%;
  height: calc(1.5em + 0.75rem + 2px);
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #fff;
  border: none;
  background-color: #fff0;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-bottom: 2px solid #565555;
  border-radius: 0px;
  padding: 0px;
}
.three_row .custom-select {
  width: 32%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #747d82;
  vertical-align: middle;
  background-color: #fff0;
  border: 1px solid #ced4da00;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-bottom: 2px solid #565555;
  border-radius: 0px;
  float: left;
  margin: 0;
  left: 0;
}
.two_row .custom-select,
.custom-select {
  width: 49%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #747d82;
  vertical-align: middle;
  background-color: #fff0;
  border: 1px solid #ced4da00;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-bottom: 2px solid #565555;
  border-radius: 0px;
  float: left;
  margin: 0;
  left: 0;
}
.custom-input {
  color: #868484;
}
.column_check {
  float: left;
  width: 33%;
  padding: 1.5px 0px;
}

.column_check label {
  color: #868484;
  font-size: 16px;
  font-weight: 500;
  margin-left: 18px;
}
.two_row {
  width: 95%;
}
.select_three_row {
  max-width: 96%;
}

.invalid-feedback {
  display: none;
  width: 30%;
  margin-top: 0.25rem;
  font-size: 100%;
  color: #dc3545;
}
.button_next {
  width: 45%;
  float: right;
  margin-right: 30px;
  padding: 20px 0px 40px 0px;
}
.button_body {
  width: 25%;
  right: 0;
  float: right;
  padding-top: 25px;
  background: #07cddb;
  padding: 10px 0px;
  width: 45%;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
}
.step_two_button {
  padding: 30px 0px;
  margin-left: -30px;
}
.congrats_body {
  padding-bottom: 10%;
}
.button_body_steptwo {
  width: 45%;
  right: 0;
  padding-top: 25px;
  background: #07cddb;
  padding: 10px 0px;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
}
.button_body_1 {
  right: 0;
  float: right;
  padding-top: 25px;
  background: #07cddb;
  padding: 10px 0px;
  width: 45%;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
  margin-right: 40px;
}
.button_body_submit {
  right: 0;
  float: right;
  padding-top: 25px;
  background: #07cddb;
  padding: 10px 0px;
  width: 25%;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
  margin-right: 40px;
}
.button_body_pre {
  width: 25%;
  left: 0;
  float: left;
  padding-top: 25px;
  padding: 10px 0px;
  width: 45%;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
  margin-right: 30px;
  z-index: 1012;
}

.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  color: #000;
  background-color: #07cddb !important;
  border-color: #07cddb !important;
}

.btn-primary {
  color: #000;
  background-color: #07cddb !important;
  border-color: #07cddb !important;
  margin-right: 5px;
  padding: 20px;
  border-radius: 25px;
}
.border_line_reg {
  height: 3px;
  color: red;
  background-color: currentColor;
  transition: 1s 0.2s ease-out;
}
.bv-no-focus-ring p {
  font-size: 18px;
  font-weight: 600;
  margin-top: -10px;
}
p {
  margin-top: 0;
  margin-bottom: 0rem;
}
.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  font-size: 16px;
  font-weight: 500;

  color: #706f6f;
}
.column_check label {
  width: 20vw;
}
.form-group {
  margin-bottom: 1rem;
  width: 40vw;
}
.Congratulations_body {
  text-align: center;
  margin-top: 20%;
}
.Congratulations_body p {
  font-size: 24px;
}
.button_body_con {
  right: 0;
  padding-top: 25px;
  background: #07cddb;
  padding: 10px 0px;
  width: 25%;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 40px;
}
.permission_text h4 {
  font-size: 18px;
  padding-bottom: 15px;
}
.permission_text label {
  font-size: 16px;
  color: #868484;
}
.button_body {
  margin-right: 25px;
}
.count_head {
  font-size: 32px;
}
.title_is {
  text-align: right;
  right: 20px;
  left: auto;
  margin-right: 60px;
  font-size: 18px;
}
.title_is span {
  font-size: 18px;
  color: #07cddb;
}
@media (max-width: 1600px) {
  .reg_left {
    padding-top: 70px;
    width: 90%;
    margin-left: 15px;
  }
  .button_body {
    margin-right: 20px;
    width: 60%;
  }
  .button_body_pre {
    width: 60%;
  }
  .button_body_steptwo {
    width: 60%;
  }
  .button_body_1 {
    margin-right: 20px;
    width: 60%;
  }
  .count_head {
    font-size: 32px;
  }
  .title_is {
    text-align: right;
    right: 20px;
    left: auto;
    margin-right: 30px;
    font-size: 18px;
  }
  .title_is span {
    font-size: 18px;
    color: #07cddb;
  }
}
@media (max-width: 1366px) {
  .reg_left .select_three_row {
    max-width: 97.5%;
  }
  .reg_left .two_row {
    width: 96.5%;
  }
}
@media (max-width: 1280px) {
  .reg_left .select_three_row,
  .reg_left .two_row {
    max-width: 88%;
  }
  .reg_left .two_row {
    width: 88%;
  }
}
@media (max-width: 1200px) {
  .column_check label {
    width: 15vw;
  }
  .form-group {
    margin-bottom: 1rem;
    width: 45vw;
  }
  .reg_left .select_three_row {
    max-width: 100%;
  }
  .reg_left .two_row {
    width: 100%;
    max-width: 100%;
  }
}
@media (max-width: 1024px) {
  .Congratulations_body {
    text-align: center;
    margin-top: 5%;
  }
  .button_body {
    padding: 8px 0px;
    width: 65%;
    font-size: 16px;
  }
  .button_body_1 {
    padding: 8px 0px;
    width: 65%;
    font-size: 16px;
  }
  .button_body {
    margin-right: 30px;
  }
  .button_body_con {
    padding: 8px 0px;
    width: 30%;
  }
  .button_body_pre {
    padding-top: 25px;
    padding: 8px 0px;
    width: 65%;
    font-size: 16px;
  }
  .button_body_steptwo {
    font-size: 16px;
    padding: 8px 0px;
  }
  .button_body_submit {
    width: 30%;
    padding: 8px 0px;
  }
}
@media (max-width: 990px) {
  .col {
    -ms-flex-preferred-size: 0;
    flex-basis: auto;
  }
  .registrtion {
    margin-top: 0px;
  }
  .column_check label {
    width: 17vw;
  }
  .count_body .col {
    flex-basis: 0;
  }
  .drop_down {
    color: #07cddb;
    position: top;
    top: 11px;
    /* right: 0; */
    right: 6px;
    position: absolute;
    z-index: -1;
  }
  .title_is {
    margin-right: 70px;
    font-size: 18px;
  }
  .form-group {
    width: 80vw;
  }
  .column_check label {
    width: 25vw;
  }
  .btn-primary {
    color: #000;
    background-color: #07cddb !important;
    border-color: #07cddb !important;

    margin-right: 15px;
    padding: 20px;
    border-radius: 25px;
    width: 100px;
    height: 30px;
  }
  .button_body_steptwo {
    width: 20%;
    right: 0;
    padding-top: 25px;
    background: #07cddb;
    padding: 10px 0px;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 600;
    float: right;
  }
  .reg_left {
    padding-top: 0px;
    width: 90%;
    justify-content: center;
    margin-left: 60px;
  }
  .Congratulations_body {
    margin-top: 4%;
    margin-left: -35px;
  }
  .button_body_pre {
    padding-top: 25px;
    padding: 10px 0px;
    width: 20%;
    position: absolute;
  }
  .button_body {
    padding: 8px 0px;
    width: 20%;
    margin-top: 20px;
  }
  .button_body_1 {
    padding: 8px 0px;
    width: 40%;
    margin-top: 20px;
    margin-right: 60px;
  }
  .button_body_submit {
    width: 20%;
    padding: 8px 0px;
  }
  .registration {
    padding-bottom: 0px;
  }
  .registrtion .select_three_row {
    max-width: 102%;
  }
  .registrtion .startDate input {
    width: 100%;
  }
  .registrtion .two_row {
    width: 102%;
    max-width: 102%;
  }
  .registrtion .reg_left {
    margin-left: -50px !important;
  }
  .registrtion .title_is {
    text-align: center;
    margin-right: -60px;
    right: 0px;
    left: auto;
  }
  .registrtion .button_next {
    margin-right: 120px;
    padding: 20px 0px 70px 0px;
  }
  .step_two_button {
    padding: 50px 0;
    margin-left: 0px;
  }
  .reg_body_fv {
    width: 100%;
  }
  .registrtion .button_1 {
    margin-right: 0px;
  }
}
@media (max-width: 920px) {
  .registrtion .reg_left {
    margin-left: -30px !important;
  }
  .reg_left .form-group {
    width: 89vw;
  }
  .registrtion .reg_left {
    margin-left: -55px !important;
  }
}
@media (max-width: 860px) {
  .registrtion .select_three_row {
    max-width: 100%;
  }
  .registrtion .reg_left {
    margin-left: -35px !important;
  }
  .registrtion .select_three_row {
    max-width: 102%;
  }
}
@media (max-width: 820px) {
  .registrtion .reg_left {
    margin-left: -5px !important;
  }
  .registrtion .select_three_row {
    max-width: 101%;
  }
  .registrtion .two_row {
    width: 101%;
    max-width: 101%;
  }
}
@media (max-width: 767px) {
  .col {
    -ms-flex-preferred-size: 0;
    flex-basis: auto;
  }
  .step_two_button {
    margin-left: -15px;
  }
  .button_body_steptwo {
    width: 26%;
  }
  .button_body_pre {
    width: 24%;
  }
  .reg_body_fv {
    position: relative;
  }
  .three_row .form-control {
    width: 100% !important;
    background: #fff0;
    border: 0px solid #fff0;
    border-bottom: 2px solid #565555;
    font-weight: 600;
    padding: 0;
    border-radius: 0px;
  }
  .select_three_row .drop_down {
    color: #07cddb;
    position: top;
    top: 11px;
    /* right: 0; */
    right: -25px;
    position: absolute;
    z-index: -1;
  }
  .calender_icon {
    color: #07cddb;
    position: absolute;
    justify-content: right;
    right: -25px;
    top: 10px;
    z-index: -1;
  }
  .two_row .drop_down {
    right: -98px;
  }
  .title_is {
    left: auto;
    margin-right: 10px;
    font-size: 18px;
  }
  .count_head {
    font-size: 28px;
  }
  .modal-overlay {
    top: -100vh;
    left: 0;
    right: 0;
    bottom: -100vh;
    z-index: 1021;
    background-color: rgb(8 8 8 / 75%);
    height: auto;
    overflow: hidden;
  }
  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 99;
    display: block;
    width: 90%;
    max-width: 700px;
    border-radius: 16px;
    padding: 25px;
    height: auto;
    z-index: 1022;
  }
  .popup-button {
    padding: 10px 25px;
    font-size: 12px;
  }
  .popup-button_b {
    font-size: 12px;
  }
  #test {
    width: 100%;
    position: absolute;
    margin-top: -150px;
  }
  .modal h1 {
    font-size: 16px;
    font-weight: 900;
    margin-bottom: 15px;
    padding-top: 40px;
  }
  .button_body {
    margin-right: -20px;
  }
  .column_check label {
    width: 30vw;
  }
  .reg_left {
    padding-top: 0px;
    width: 90%;
    justify-content: center;
    margin-left: 15px;
  }
  .reg_left .form-group {
    width: 80vw;
  }
  .btn-primary {
    color: #000;
    background-color: #07cddb !important;
    border-color: #07cddb !important;
    margin-right: 5px;
    padding: 20px;
    border-radius: 25px;
    width: 100px;
    height: 30px;
  }

  .one_row .form-control {
    width: 100%;
  }
  .two_row .form-control {
    display: block;
    width: 100%;
  }
  .three_row .custom-select {
    width: 100%;
  }
  .two_row .custom-select {
    width: 100%;
  }
  .button_body_con {
    padding: 8px 0px;
    width: 25%;
    font-size: 18px;
    font-weight: 600;
  }
  .Congratulations_body {
    margin-top: 4%;
    margin-left: 30px;
  }
  .Congratulations_body img {
    margin-left: 10px;
  }
  .button_body {
    padding: 6px 0px;
  }
  .button_body_1 {
    padding: 9px 0px;
    margin-right: 0px;
  }
  .button_body_pre {
    margin-left: 50px;
  }
  .registrtion .reg_left {
    margin-left: -40px !important;
  }
  .registrtion .title_is {
    text-align: right;
    margin-right: 40px;
    right: 20px;
    left: auto;
  }
  .registrtion .select_three_row {
    max-width: 100%;
  }
  .registrtion .two_row {
    width: 88%;
  }
}
@media (max-width: 683px) {
  .calender_icon {
    color: #07cddb;
    position: absolute;
    justify-content: right;
    right: -25px;
    top: 10px;
    z-index: -1;
  }
  .registrtion .button_1 {
    margin-right: 30px;
  }
  .two_row .drop_down {
    right: -86px;
  }
  .registrtion .reg_left {
    margin-left: -15px !important;
  }
  .registrtion .title_is {
    margin-right: 30px;
  }

  .registrtion .two_row {
    width: 89%;
  }
  .reg_left .form-group {
    width: 80vw;
  }
}
@media (max-width: 640px) {
  .reg_left .form-group {
    width: 85vw;
  }
}
@media (max-width: 600px) {
  .button_body_pre {
    margin-left: 35px;
    width: 25%;
  }
  .button_body_steptwo {
    width: 25%;
  }
  .registrtion .reg_left {
    margin-left: 10px !important;
  }

  .button_body_1 {
    padding: 10px 0px;
    width: 55%;
  }
  .button_body_submit {
    width: 25%;
    padding: 8px 0px;
  }
  .step_two_button {
    padding: 50px 0;
    margin-left: -50px;
  }
  .reg_left .form-group {
    width: 85vw;
  }
}
@media (max-width: 583px) {
  .reg_left .form-group {
    width: 88vw;
  }
}
@media (max-width: 576px) {
  .select_three_row .drop_down {
    right: -10px;
  }
  .calender_icon {
    right: -10px;
  }
  .two_row .drop_down {
    right: -60px;
  }
  .reg_left .form-group {
    width: 90vw;
  }
}

@media (max-width: 480px) {
  .reg_left {
    padding-top: 0px;
    margin-left: 5px;
  }
  .invalid-feedback {
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 100%;
    color: #dc3545;
  }
  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 99;
    display: block;
    width: 95%;
    max-width: 700px;
    border-radius: 16px;
    padding: 25px;
    height: auto;
  }
  .popup-button {
    padding: 10px 10px;
    font-size: 11px;
  }
  .popup-button_b {
    padding: 10px 10px;
    font-size: 11px;
  }
  #test {
    width: 100%;
    position: absolute;
    margin-top: -150px;
  }
  .modal h1 {
    font-size: 13px;
    font-weight: 900;
    margin-bottom: 15px;
    padding-top: 40px;
  }
  .button_body_con {
    right: 0;
    padding-top: 25px;
    background: #07cddb;
    padding: 6px 0px;
    width: 35%;
    border-radius: 25px;
    font-size: 18px;
    font-weight: 600;
  }
  .button_body_1 {
    right: 0;
    float: right;
    padding-top: 0px;
    margin-top: 0px;
    background: #07cddb;
    padding: 8px 0px;
    width: 65%;
    border-radius: 25px;
    font-size: 12px;
    font-weight: 600;
  }
  .Congratulations_body {
    text-align: center;
    margin-top: 4%;
    margin-left: 25px;
  }
  .button_body {
    padding: 6px 0px;
    width: 30%;
    margin-right: 5px;
    font-size: 14px;
  }
  .button_body_pre {
    padding: 8px 0px;
    width: 30%;
    z-index: 1021;
  }
  .button_body_pre {
    padding-top: 25px;
    padding: 8px 0px;
    width: 30%;
    margin-left: 40px;
    font-size: 14px;
  }
  .button_body_steptwo {
    width: 30%;
    padding: 8px 0px;
    font-size: 14px;
  }
  .button_body_submit {
    width: 30%;
    padding: 8px 0px;
  }
  .button_body_con {
    padding: 8px 0px;
    width: 30%;
    font-size: 18px;
    font-weight: 600;
  }
  .column_check label {
    width: 36vw;
  }
  .reg_left {
    padding-top: 0px;
    margin-left: 0px;
  }
  .registrtion .reg_left {
    margin-left: 5px !important;
  }
  .registrtion .title_is {
    margin-right: 20px;
  }

  .registrtion .two_row {
    width: 92%;
  }
  .step_two_button {
    padding: 50px 0;
    margin-left: -30px;
  }

  .two_row .drop_down {
    right: -44px;
  }
}
@media (max-width: 400px) {
  .button_body_pre {
    padding-top: 25px;
    padding: 6px 0px;
    width: 30%;
    margin-left: 40px;
  }

  .button_body_steptwo {
    width: 30%;
    padding: 6px 0px;
  }
  .button_body_con {
    padding: 6px 0px;
    width: 30%;
    font-size: 18px;
    font-weight: 600;
  }
  .column_check label {
    width: 40vw;
  }
  .bv-no-focus-ring p {
    font-size: 16px;
    font-weight: 500;
    margin-top: -10px;
  }
  span {
    font-size: 12px;
  }
  .reg_left {
    padding-top: 0px;
    margin-left: -5px;
  }
  .registrtion .reg_left {
    margin-left: 0px !important;
  }
  .registrtion .title_is {
    margin-right: 5px;
  }
  .select_three_row .drop_down {
    right: -18px;
  }
  .calender_icon {
    right: -18px;
  }
}

@media (max-width: 990px) and (orientation: landscape) {
  .modal {
    position: fixed;
    top: 60%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 99;
    display: block;
    width: 90%;
    max-width: 700px;
    border-radius: 16px;
    padding: 15px;
    height: auto;
  }
  .step_two_button {
    padding: 50px 0;
    margin-left: 0px;
  }
}
@media only screen and (max-width: 768px) and (orientation: landscape) {
}
@media (max-width: 583px) and (orientation: landscape) {
  .step_two_button {
    padding: 50px 0;
    margin-left: -30px;
  }
}
</style>
